import {Select,MenuItem,Typography,FormHelperText,} from "@mui/material";
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import Colors from "../../../assets/Variables/ColorsVariables.js";
import { Spaces } from "../../../assets/Variables/SpaceVariables.js";

const TitledSelectorSlim = ({
  title,
  value,
  handleChange,
  options,
  error,
  helperText,
  placeholder,
  name,
  disabled = false,
  height = "24px",
  width = "100%",
  size = "slim",
  variant = "default",
}) => {

  //Label Styles (Statements)
  const statementsTitleStyle = {
    fontFamily: "Plus Jakarta Sans, sans-serif",
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "140%",
    color: Colors.Secondary_700,
    marginRight: 0,
    marginBottom: "4px",
  };

  const defaultTitleStyle = {
    marginRight: "10px",
    marginBottom: "5px",
    fontFamily: TextVariables.Body_4,
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "140%",
    color: Colors.Secondary_900,
  };

  const titleStyle = variant === "statements" ? statementsTitleStyle : defaultTitleStyle;

  //Select Styles Statements
  const statementsSelectStyle = {
    width: "131px",
    height: "40px",
    borderRadius: Spaces.Size_2,
    border: `1px solid ${Colors.Secondary_700}`,
    fontFamily: TextVariables.Body_4,
    fontSize: "12px",
    padding: "0px",
    backgroundColor: Colors.Gray_50,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-select": {
      py: Spaces.Size_3,
      px: Spaces.Size_3,
      display: "flex",
      alignItems: "center",
      height: "100%",
    },
    "&:hover": {
      borderColor: `${Colors.Secondary_700} !important`,
    },
  };

  const defaultSelectStyle = {
    fontFamily: TextVariables.Body_4,
    borderRadius: Spaces.Size_2,
    width: width,
    height: height,
    padding: "0px",
    fontSize: "12px",
    lineHeight: "16px",
    border: error 
      ? `1px solid ${Colors.Error_700}` 
      : disabled 
      ? `1px solid ${Colors.Gray_200}` 
      : `1px solid ${Colors.Secondary_400}`,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-select": {
      py: "4px 8px !important",
      display: "flex",
      alignItems: "center",
    },
    "&:hover": {
      borderColor: `${Colors.Secondary_700} !important`,
    },
  };

  const selectStyle = variant === "statements" ? statementsSelectStyle : defaultSelectStyle;

  return (
    <div style={{ width: "100%" }}>
      {title && (
        <Typography variant="h6" sx={titleStyle}>
          {title}
        </Typography>
      )}
      <Select
        value={value}
        onChange={handleChange}
        sx={selectStyle}
        inputProps={{ name: name }}
        displayEmpty
        disabled={disabled}
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 200 },
          },
        }}
      >
        <MenuItem value="" disabled>
          <Typography sx={{
            fontFamily: TextVariables.Body_4,
            fontSize: "12px",
            color: Colors.Gray_400,
          }}>
            {placeholder}
          </Typography>
        </MenuItem>
        {options.map((option, index) => (
          <MenuItem
            key={index}
            value={option.value}
            sx={{ 
              fontFamily: TextVariables.Body_4,
              fontSize: "12px",
              py: 0.5,
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
};

export default TitledSelectorSlim;